import React, { useState, useContext } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle, faSyncAlt, faRedoAlt } from '@fortawesome/free-solid-svg-icons';
import { CandidateContext } from '../../../../context/CandidateContext';
import { API } from '../../../../http-common';
import { useSnackbar } from 'react-simple-snackbar';
import { TIPOS_ASESOR } from '../../../../helpers/tipoAsesor'

export const EmploymentStatusAlert = ({ employmentStatus, tipoAsesor }) => {
	const [syncModalOpen, setSyncModalOpen] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [tempStatusMessage, setTempStatusMessage] = useState(null);
	const { candidateData, setCandidateData } = useContext(CandidateContext);
	
	const optionsError = {
		position: 'bottom-right',
		style: {
			backgroundColor: 'var(--bs-red)',
			border: '0',
			color: '#fff',
			fontSize: '20px',
			textAlign: 'center',
			marginBottom: '5rem',
		},
		closeStyle: {
			color: '#fff',
			fontSize: '16px',
			marginRight: '1rem',
		},
	};

	const optionsSuccess = {
		position: 'bottom-right',
		style: {
			backgroundColor: 'var(--bs-green)',
			border: '0',
			color: '#fff',
			fontSize: '20px',
			textAlign: 'center',
			marginBottom: '5rem',
		},
		closeStyle: {
			color: '#fff',
			fontSize: '16px',
			marginRight: '1rem',
		},
	};

	const [openSnackbarSuccess] = useSnackbar(optionsSuccess);
	const [openSnackbarError] = useSnackbar(optionsError);
	
	const status = Number(employmentStatus);
	
	if (tempStatusMessage) {
		return (
			<>
				<div className="row" style={{ padding: '0 10%', width: '100%', margin: 0 }}>
					<div className="p-0" style={{ width: '100%' }}>
						<div className="container-table">
							<div
								className="d-flex align-items-center p-4"
								style={{
									backgroundColor: '#24589c',
									color: '#fff',
									borderRadius: 0,
									boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
									marginBottom: '1.5rem',
								}}
							>
								<div className="d-flex align-items-center">
									<FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: 22, color: '#fff' }} className="me-3" />
									<div style={{ fontSize: 16, fontWeight: 600 }}>
										{tempStatusMessage}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</>
		);
	}
	
	if (![-2,-1,0,1,2].includes(status)) return null;

	const handleResync = () => {
		setSyncModalOpen(true);
	};

	const handleConfirmResync = async () => {
		setIsLoading(true);
		try {	
			const response = await API.post(`/prospects/refresh/status/${candidateData.id}`);
			const { data } = response;
			
			if (data.employment_status === 0) {
				setTempStatusMessage("El usuario no es ni empleado ni ex-empleado");
				openSnackbarSuccess(data.message || 'Sincronización completada: Usuario no es empleado ni ex-empleado');
			} else {
				setCandidateData(prevData => ({
					...prevData,
					employment_status: data.employment_status
				}));
				setTempStatusMessage(null);
				openSnackbarSuccess(data.message || 'Sincronización completada exitosamente');
			}
			
			setSyncModalOpen(false);
			
		} catch (error) {
			console.error('Error en sincronización:', error);
			const errorMessage = error.response?.data?.message || 'Error al sincronizar los datos';
			openSnackbarError(errorMessage);
		} finally {
			setIsLoading(false);
		}
	};

	let message, iconComponent, showButton = false, backgroundColor = '#24589c', buttonText = '', textColor = '#fff';

	const textoAsesor = TIPOS_ASESOR.find(item => item.idTipoAsesor === tipoAsesor)?.Descripcion ?? '';


	switch (status) {
		case 1:
			message = `El candidato figura como <b>ACTIVO</b> en la API de Balanz${
				textoAsesor ? ` con el tipo de asesor ${textoAsesor} (${tipoAsesor})` : ''
			}.`;
			iconComponent = <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: 22, color: '#fff' }} className="me-3" />;
			backgroundColor = '#24589c';
			textColor = '#fff';
			break;
		case 2:
			message = `El candidato figura como <b>BAJA</b> en la API de Balanz${
				textoAsesor ? ` con el tipo de asesor ${textoAsesor} (${tipoAsesor})` : ''
			}.`;
			iconComponent = <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: 22, color: '#fff' }} className="me-3" />;
			backgroundColor = '#24589c';
			textColor = '#fff';
			break;
		case 0:
			message = `El candidato no figura ni como empleado ni como ex-empleado`;
			iconComponent = <FontAwesomeIcon icon={faInfoCircle} style={{ fontSize: 22, color: '#fff' }} className="me-3" />;
			backgroundColor = '#24589c';
			textColor = '#fff';
			break;
		case -1:
			message = 'Seleccione sincronizar para confirmar si es exempleado Balanz';
			iconComponent = <FontAwesomeIcon icon={faSyncAlt} style={{ fontSize: 22, color: '#212529' }} className="me-3" />;
			showButton = true;
			backgroundColor = '#ffc107';
			buttonText = 'Sincronizar';
			textColor = '#212529';
			break;
		case -2:
			message = 'Seleccionar volver a sincronizar, para confirmar si es exempleado Balanz. De lo contrario Avanzar.';
			iconComponent = <FontAwesomeIcon icon={faSyncAlt} style={{ fontSize: 22, color: '#fff' }} className="me-3" />;
			showButton = true;
			backgroundColor = '#dc3545';
			buttonText = 'Volver a sincronizar';
			textColor = '#fff';
			break;
		default:
			return null;
	}

	return (
		<>
			<div className="row" style={{ padding: '0 10%', width: '100%', margin: 0 }}>
				<div className="p-0" style={{ width: '100%' }}>
					<div className="container-table">
						<div
							className={`d-flex align-items-center p-4 ${showButton ? 'justify-content-between' : ''}`}
							style={{
								backgroundColor: backgroundColor,
								color: textColor,
								borderRadius: 0,
								boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
								marginBottom: '1.5rem',
							}}
						>
							<div className="d-flex align-items-center">
								{iconComponent}
								<div style={{ fontSize: 16, fontWeight: 600 }} dangerouslySetInnerHTML={{ __html: message }} />
							</div>
							{showButton && (
								<button
									type="button"
									className="btn btn-light"
									onClick={handleResync}
									style={{
										fontSize: 14,
										fontWeight: 600,
										padding: '8px 16px',
										borderRadius: '4px',
										border: 'none',
										boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
										cursor: 'pointer',
										transition: 'all 0.2s ease',
									}}
									onMouseOver={(e) => {
										e.target.style.backgroundColor = '#f8f9fa';
										e.target.style.transform = 'translateY(-1px)';
									}}
									onMouseOut={(e) => {
										e.target.style.backgroundColor = '#fff';
										e.target.style.transform = 'translateY(0)';
									}}
								>
									<FontAwesomeIcon icon={faRedoAlt} className="me-2" />
									{buttonText}
								</button>
							)}
						</div>
					</div>
				</div>
			</div>

			{/* Modal de confirmación de sincronización */}
			<Modal isOpen={syncModalOpen} className="" id="sync_modal">
				<ModalHeader className="justify-content-end">
					<button 
						className="close bg-transparent border-0" 
						onClick={() => setSyncModalOpen(false)}
						disabled={isLoading}
					>
						<span>&times;</span>
					</button>
				</ModalHeader>
				<ModalBody className="modal-body">
					<p className="modal_title red_text">
						Confirmar Sincronización
					</p>
					<p className="modal_text_info">
						¿Está seguro de que desea reintentar la sincronización de datos? 
						Este proceso puede tomar unos momentos.
					</p>
					<div className="row modal_btns">
						<button
							type="button"
							className="btn blue_btn"
							onClick={handleConfirmResync}
							disabled={isLoading}
						>
							{isLoading ? (
								<>
									<div className="d-flex align-items-center justify-content-center">
										<Spinner style={{ 'margin-right': '5px' }} size="sm" animation="border" />
										<span>Sincronizando...</span>
									</div>
								</>
							) : 'Confirmar'}
						</button>
						<button 
							type="button" 
							className="btn red_btn" 
							onClick={() => setSyncModalOpen(false)}
							disabled={isLoading}
						>
							Cancelar
						</button>
					</div>
				</ModalBody>
			</Modal>
		</>
	);
};

